<script setup>
import { RouterLink } from "vue-router";
import { sendMetrik } from "@/utils/metrika";
</script>
<template>
	<section class="games" id="games">
		<div class="container">
			<h2 class="games__title title2">Игры</h2>
			<div class="games__container">
				<div class="game">
					<div class="game__image">
						<img class="full-img" width="400" height="400" src="@/assets/img/games/game_1.webp" alt="изображение" />
					</div>
					<div class="game__content">
						<h3 class="game__title">Арт-филворд</h3>
						<p class="game__desc">Найдите слова, спрятанные в сетке букв — все они связаны с искусством, известными картинами, художниками и крупами!</p>
						<RouterLink @click="sendMetrik('reachGoal', 'Fillword')" to="/quiz_fill_words" class="game__btn btn"> Играть </RouterLink>
					</div>
				</div>
				<div class="game">
					<div class="game__image">
						<img class="full-img" width="400" height="400" src="@/assets/img/games/game_2.webp" alt="изображение" />
					</div>
					<div class="game__content">
						<h3 class="game__title">Шедевры в эмодзи</h3>
						<p class="game__desc">Эмодзи — современный визуальный язык знакомый каждому. Больше игр — больше шансов выиграть приз.</p>
						<RouterLink @click="sendMetrik('reachGoal', 'Emojis')" to="/quiz_emoji" class="game__btn btn">Играть</RouterLink>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.games {
	background-image: url("@/assets/img/games/games_bg.webp");
	background-repeat: no-repeat;
	background-position: center top; /* x y*/
	background-size: cover; /* w h*/
	padding: 8.7rem 0 22rem;
	@media (max-width: vars.$mn) {
		padding: 8.7rem 0 18rem;
	}
	@media (max-width: vars.$xx) {
		padding: 8.7rem 0 26rem;
	}
	@media (max-width: vars.$x480) {
		background-image: url("@/assets/img/games/games_bg_mobile.webp");
		padding: 3.8rem 0 11.5rem;
	}
}

.games__title {
	color: var(--text-inverse-100);
	@media (max-width: vars.$x480) {
		margin-bottom: 50px;
	}
}

.games__container {
	padding: 0 19.6rem;
	@media (max-width: vars.$l) {
		padding: 0;
	}
}
.game {
	color: var(--text-inverse-100);
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 4.5rem;
	@media (max-width: vars.$xx) {
		flex-direction: column;
		gap: 3.3rem;
	}
	&:first-child {
		margin-bottom: 4rem;
		padding-bottom: 1rem;
		border-bottom: 1px solid currentColor;
		@media (max-width: vars.$x480) {
			padding-bottom: 4rem;
		}
	}
	&:last-child {
		flex-direction: row-reverse;
		@media (max-width: vars.$xx) {
			flex-direction: column;
		}
	}
}
.game__image {
	width: 43rem;
	flex-shrink: 0;
	border-radius: var(--border-radius);
	overflow: hidden;
	@media (max-width: vars.$x480) {
		width: 30rem;
		margin: 0 auto;
	}
	img {
		aspect-ratio: 1/1;
	}
}

.game__content {
	display: grid;
	gap: 1.6rem;
	padding-bottom: 5rem;
	@media (max-width: vars.$x480) {
		gap: 18px;
		padding-bottom: 0;
	}
}
.game__title {
	font-weight: 700;
	font-size: 4rem;
	line-height: 140%;
	text-transform: uppercase;
	@media (max-width: vars.$x480) {
		font-size: 2.4rem;
	}
}
.game__desc {
	font-weight: 400;
	font-size: 2.4rem;
	line-height: 140%;
	@media (max-width: vars.$x480) {
		font-size: 2rem;
		line-height: 160%;
	}
}
.game__btn {
	width: fit-content;
	// pointer-events: none;
	@media (max-width: vars.$x480) {
		width: 100%;
	}
}
</style>
